import React from 'react';

const VideoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative w-full max-w-3xl mx-auto p-4">
        {/* Close button */}
        <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 text-white bg-red-600 hover:bg-red-700 rounded-full p-2 transition focus:outline-none"
        >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        </button>


        {/* Video */}
        <div className="w-full pt-[56.25%] relative rounded-xl overflow-hidden shadow-lg">
        <iframe
            className="absolute top-0 left-0 w-full h-full"
            src="https://www.youtube.com/embed/1GQJB1OF7bo"
            title="Video informativo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        />
        </div>

      </div>
    </div>
  );
};

export default VideoModal;
